<template>
  <div class="component-container">
    <h3>4PNG Energy and Waves (Second Edition) - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <p>Please download and save to your Google drive for your classroom. Presentation can be used in Google slides or Powerpoint.</p>
      <ul>
      <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F4PNG-2E_Activities_1-8_08262024.zip?alt=media&token=6163e66f-e5c6-43df-9828-6b4f7c572cf6" target="_blank">Activities 1-8 (Zip File) Updated 8/26/2024</a></li>
    
      <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links</a> - A spreadsheet of all of the links in our K-5 Teacher Guides (Updated 4/24/2024) - Report broken links to info@bcamsc.org.</li>
      <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=822445013#gid=822445013">Curriculum Updates Spreadsheet</a> - List of links to updates for printed materials.</li>
    </ul>
      <!-- <p style="margin-left: 40px;">Activities 6-8 Coming November 2020!</p> -->
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1Kt5_E5QqyYzG5mnSoUZiMbvcyyzYJGmMDjSK2bVlGbU/copy" target="_blank">4PNG Energy and Waves (Second Edition) Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1pgG3XQdCg2HnS-QvSVf8SitNBDTTSCcn/view" target="_blank">4PNG Energy and Waves (Second Edition) Student Journal Answer Key</a></li>
        <li><a href="https://docs.google.com/presentation/d/1IPElBKUF8TaSxjhm6foP_f_uTxIJ0h1HaHtFRZz_p-o/copy" target="_blank">4PNG Energy and Waves (Second Edition) Student Journal - SPANISH</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies of Jamboards and Slide Decks and save in your Google drive for your classroom.</p>
      <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
      <ul>
        <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F4PNG-2E_TechnologySupplement_06292022.pdf?alt=media&token=0cf7c1e0-d31a-4fe0-bd17-65fa9c4befbd" target="_blank">4PNG Second Edition - Technology Lessons (PDF) with Computer Science Standards Integration using SageModeler. These lessons replace Lessons 2B, 2C, 3A, and 6A in your printed 4PNG Second Edition Teacher Guide.</a></li>
        <li><a href="https://docs.google.com/presentation/d/1s8n4fqb_Kln9NMafMtcwjQI8CTYOpigf3925_ja99_A/copy" target="_blank">What We Think Chart</a></li>
        <li><a href="https://docs.google.com/presentation/d/1sBJLRXNDzsooCZOXB1KEuVrFHE7qwzHi-fYUDXOknSw/copy" target="_blank">Classroom Anchor Posters</a></li>
        <li><a href="https://docs.google.com/presentation/d/1dWCiM00OxdxvLwmyEZzrTfUoR39t5yQV-1yxvpyT23c/copy" target="_blank">Word Wall</a></li>

        
        <!-- <li><a href="" target="_blank">4PNG </a></li> -->
      </ul>
      <h4 style="margin-left: 10px;">Demonstration Videos</h4>
      <ul>
        <li><a href="https://drive.google.com/file/d/1k7FsJJIBP66N37dmQBT23K9IC41Y74J1/view?usp=sharing" target="_blank">Ball Collisions: Different Weight, One Moving</a></li>
        <li><a href="https://drive.google.com/file/d/17pM1gqCu-4Bn9cdgdV-sZKsXn_iCfCNR/view?usp=sharing" target="_blank">Ball Collisions: Different Weight, Two Moving, Same Speed</a></li>
        <li><a href="https://drive.google.com/file/d/1BrsVOZIWesrqkISQIpP_9ngbuZ7Z_ClC/view?usp=sharing" target="_blank">Ball Collisions: Same Weight, One Moving</a></li>
        <li><a href="https://drive.google.com/file/d/1ktGCZmg5AcUtacR-3NahT_iGTPl8TOaD/view?usp=sharing" target="_blank">Ball Collisions: Same Weight, Two Moving, Different Speeds</a></li>
        <li><a href="https://drive.google.com/file/d/1XuUA3PpHSoiLADqLa-s5Z4TVGADrflMv/view?usp=sharing" target="_blank">Ball Collisions: Same Weight, Two Moving, Same Speed</a></li>
        <li><a href="https://drive.google.com/file/d/1op2uWG0jmFB0tUrgefxPMCrSdQQ7Skcp/view?usp=sharing" target="_blank">Ball Drop: Measure Bounce</a></li>
        <li><a href="https://drive.google.com/file/d/1dkgfiMCzSkMD02XpFJDRQlShLcD59iDv/view?usp=sharing" target="_blank">Tennis Ball Drop</a></li>
        <li><a href="https://drive.google.com/file/d/1x0Q4Mq_gUDRqpTwctTi15PR9poVPBMnQ/view?usp=sharing" target="_blank">Basketball Drop</a></li>
        <li><a href="https://drive.google.com/file/d/1dkPn6oSv6HxodpcMLwRi-gP4BCwQ-2DK/view?usp=sharing" target="_blank">Basketball on Tennis Ball Drop</a></li>
        <li><a href="https://drive.google.com/file/d/1yUWgN2T1USdbxYqIWTeQF4enH1tftrAb/view?usp=sharing" target="_blank">Tennis Ball on Basketball Drop</a></li>
        <li><a href="https://drive.google.com/file/d/1zcy7urJLp_UezGEN9Z-I0zkgYeZ5KnWL/view?usp=sharing" target="_blank">Domino Station</a></li>
        <li><a href="https://drive.google.com/file/d/1jNQx4hFYTDNy1RIVD1OgmHUIH66aEpP9/view?usp=sharing" target="_blank">Flashlight Batteries Station</a></li>
        <li><a href="https://drive.google.com/file/d/1X3lUAUR4CYY-w2UBdrxBErzGgNN55uva/view?usp=sharing" target="_blank">Marble Magnets Station</a></li>
        <li><a href="https://drive.google.com/file/d/1yIf6sacqFSuufpFtrDvuuANhuDje3-PE/view?usp=sharing" target="_blank">Ruler with Marker</a></li>
        <li><a href="https://drive.google.com/file/d/19BOU25JwuohTeUO33DDyCwqaerOOK5pm/view?usp=sharing" target="_blank">Tennis Ball 5cm Ramp</a></li>
        <li><a href="https://drive.google.com/file/d/1IJg-sCjo5hCFgqAQIHzWoBG0r6yRbxJI/view?usp=sharing" target="_blank">Tennis Ball 10cm Ramp</a></li>
        <li><a href="https://drive.google.com/file/d/1yJ9vrrKmL9lYpDDyY3h-jBtvGbDd6AFj/view?usp=sharing" target="_blank">Tennis Ball Ramp Station</a></li>
        <li><a href="https://drive.google.com/file/d/1XlerKBCBXfQrf5LplXKpdSAdLDIrWxXn/view?usp=sharing" target="_blank">Water Wave</a></li>
        <li><a href="https://drive.google.com/file/d/1Vl04kZ0p6P5iqm8Je4H51pALGfl8ChuM/view?usp=sharing" target="_blank">Human Wave</a></li>
        <li><a href="https://drive.google.com/file/d/167wW1QPMbaOdibn4jEczYlISdKpnskiq/view?usp=sharing" target="_blank">Configurations Attempting to Light Mini Light Bulb</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
